import { getApi } from "@/utils/http";

// 查找授权账号列表
export const getAuthAccountListApi = (params): Promise<any> => {
  const id = params.id;
  delete params.id;
  return getApi(`/api/v1/crm/tools/${id}`, params);
};

// 获取分组
export async function getAuthGroupApi(params?): Promise<any> {
  return getApi("/api/v1/crm/tools/agent/teams", params);
}
